import { create } from "zustand";
import api from "../../service/api";
import { AdminDashboard, FirmDashboard, CustomerDashboard } from "../../types/dashboard";

// ---------------- Admin Dashboard ----------------
interface AdminDashboardStore {
  data: AdminDashboard | null;
  loading: boolean;
  error: string | null;
  fetchData: () => Promise<void>;
}

export const useAdminDashboardStore = create<AdminDashboardStore>((set) => ({
  data: null,
  loading: false,
  error: null,
  fetchData: async () => {
    set({ loading: true, error: null });
    try {
      const res = await api.get("dashboard");
      set({ data: res.data, loading: false });
    } catch (err: any) {
      set({ error: err.response?.data?.message || "Veri çekilirken hata oluştu", loading: false });
    }
  },
}));

// ---------------- Firm Dashboard (WIDGET TABANLI) ----------------
interface FirmDashboardStore {
  data: FirmDashboard | null;
  loading: boolean;
  error: string | null;
  fetchData: () => Promise<void>;
}

export const useFirmDashboardStore = create<FirmDashboardStore>((set) => ({
  data: null,
  loading: false,
  error: null,
  fetchData: async () => {
    set({ loading: true, error: null });
    try {
      const res = await api.get("dashboard/firm", { headers: { "ignore-403": "true" } });
      // API artık { firmName, widgets: [] } dönüyor
      set({ data: res.data, loading: false });
    } catch (err: any) {
      if (err.response?.status === 403) {
        set({ data: { firmName: "", widgets: [] }, loading: false, error: null });
      } else {
        set({ error: err.response?.data?.message || "Veri çekilirken hata oluştu", loading: false });
      }
    }
  },
}));

// ---------------- Customer Dashboard ----------------
interface CustomerDashboardStore {
  data: CustomerDashboard | null; // Array tipinde tanımlandı
  loading: boolean;
  error: string | null;
  fetchData: () => Promise<void>;
}

export const useCustomerDashboardStore = create<CustomerDashboardStore>((set) => ({
  data: null,
  loading: false,
  error: null,
  fetchData: async () => {
    set({ loading: true, error: null });
    try {
      const res = await api.get("dashboard/customer");
      set({ data: res.data, loading: false });
    } catch (err: any) {
      set({ error: err.response?.data?.message || "Müşteri verisi çekilemedi", loading: false });
    }
  },
}));